export enum PLATFORM_HIERARCHIC_TYPE {
  INDEPENDENT = 1,
  SUB_PLATFORM = 2,
  SUPER_PLATFORM = 3,
  HYPER_PLATFORM = 4
}
